export default defineNuxtPlugin( async (nuxtApp) => {
  const config = useRuntimeConfig()

  const  { session, refresh} = await useSession()

  // const token = nuxtApp.ssrContext?.event?.context?.session?.token;
  
  
  
    const apiAuthImg = $fetch.create({
      baseURL: config.public.API_BASE_URL,
     
      
    async onRequest({ request, options, error }) {
   
      await refresh()
  
      if (session.value?.token) {
        const headers = options.headers ||= {}
        if (Array.isArray(headers)) {
          headers.push(['Authorization', `Bearer ${session.value?.token}`])
          headers.push(['Content-Type', `mutlipart/form-data`])
        } else if (headers instanceof Headers) {
          headers.set('Authorization', `Bearer ${session.value?.token}`)
          headers.set('Content-Type', `mutlipart/form-data`)
        } else {
          headers.Authorization = `Bearer ${session.value?.token}`
          headers['Content-Type'] = `mutlipart/form-data`
          
        }

      }
      
    },
    async onResponseError({ response }) {

      if (response.status === 401) {
        await nuxtApp.runWithContext(() => navigateTo('/login-admin'))
      }
    }
  })
    // Expose to useNuxtApp().$api
    return {
      provide: {
        apiAuthImg
      }
    }
  })
  
